"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.61 12.38c0 .34.05.67.12 1H3.55L1.13 15.8a.485.485 0 0 1-.54.11.499.499 0 0 1-.31-.46V4.06c0-2.21 1.79-4 4-4h7.44c2.21 0 4 1.79 4 4v5.33c0 .06-.01.11-.02.17-.1-.13-.2-.27-.32-.39-.21-.21-.43-.39-.67-.55V4.06c0-1.65-1.35-3-3-3H4.27c-1.65 0-3 1.35-3 3v10.18l1.62-1.62c.09-.14.24-.23.41-.23h4.3l.01-.01Zm4.6-9.16H3.79v1h8.42v-1Zm-8.42 4h8.42v-1H3.79v1Zm0 3H8v-1H3.79v1Zm10.89 4.68a3.555 3.555 0 0 1-5.03 0 3.555 3.555 0 0 1 0-5.03 3.555 3.555 0 0 1 5.03 0 3.555 3.555 0 0 1 0 5.03Zm-.24-2.86-1.9-.02v-1.9h-.74v1.9L9.9 12v.74l1.9.02v1.9h.74v-1.9l1.9.02v-.74Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18.383 6.075H5.618V4.95h12.765v1.125ZM4.89 18.84a.546.546 0 0 0-.465.277l-2.812 2.805v-15.9c0-2.617 2.13-4.74 4.74-4.74h11.28c2.617 0 4.74 2.13 4.74 4.74v7.71c.127.113.255.226.382.346.255.255.48.532.683.817.037-.262.06-.525.06-.795V6.022A5.874 5.874 0 0 0 17.633.157H6.353A5.874 5.874 0 0 0 .488 6.022V23.28c0 .225.135.435.345.517a.562.562 0 0 0 .615-.12l3.72-3.72h6.855a6.325 6.325 0 0 1-.143-1.125H4.89v.008Zm.72-3.668h6.382v-1.125H5.61v1.125Zm12.765-5.67H5.61v1.125h12.765V9.502Zm3.585 12.81a5.25 5.25 0 0 1-7.432 0 5.25 5.25 0 0 1 0-7.432 5.25 5.25 0 0 1 7.432 0 5.25 5.25 0 0 1 0 7.432Zm-.36-4.222-2.812-.03v-2.812h-1.095v2.804l-2.798-.03-.015 1.096 2.813.03v2.812h1.095v-2.805l2.805.03.015-1.095H21.6Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.51 8.1H7.49V6.6h17.02v1.5ZM6.52 25.12c-.26 0-.49.15-.62.37l-3.75 3.74V8.03c0-3.49 2.84-6.32 6.32-6.32h15.04c3.49 0 6.32 2.84 6.32 6.32v10.28c.17.15.34.3.51.46.34.34.64.71.91 1.09.05-.35.08-.7.08-1.06V8.03c0-4.31-3.51-7.82-7.82-7.82H8.47C4.16.21.65 3.72.65 8.03v23.01c0 .3.18.58.46.69a.75.75 0 0 0 .82-.16l4.96-4.96h9.14c-.11-.49-.17-1-.19-1.5H6.52v.01Zm.96-4.89h8.51v-1.5H7.48v1.5Zm17.02-7.56H7.48v1.5H24.5v-1.5Zm4.78 17.08a7.001 7.001 0 0 1-9.91 0 7.001 7.001 0 0 1 0-9.91 7.001 7.001 0 0 1 9.91 0 7.001 7.001 0 0 1 0 9.91Zm-.48-5.63-3.75-.04v-3.75h-1.46v3.74l-3.73-.04-.02 1.46 3.75.04v3.75h1.46v-3.74l3.74.04.02-1.46h-.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M36.877 21.023H11.122v-1.875h25.755v1.875ZM35.377.3H12.63C6.21.3.99 5.52.99 11.94v34.823c0 .382.225.72.578.87.12.044.24.067.36.067.247 0 .48-.098.66-.278l7.552-7.552h14.19a12.978 12.978 0 0 1-.27-1.875H9.66a.952.952 0 0 0-.862.563l-5.94 5.94V11.94c0-5.385 4.38-9.765 9.765-9.765H35.37c5.385 0 9.765 4.38 9.765 9.765v16.313c.038.037.075.06.105.097.6.6 1.125 1.245 1.575 1.927.12-.667.195-1.35.195-2.047V11.94C47.01 5.52 41.79.3 35.37.3h.008ZM11.122 30.195H24V28.32H11.123v1.875Zm25.755-20.22H11.122v1.875h25.755V9.975ZM43.92 29.67a10.556 10.556 0 0 1 0 14.932 10.555 10.555 0 0 1-14.933 0c-4.124-4.124-4.124-10.807 0-14.932 4.125-4.125 10.808-4.125 14.933 0Zm-.712 6.45-5.655-.067v-5.655h-2.198v5.632l-5.625-.068-.023 2.198 5.655.068v5.654h2.198V38.25l5.625.068.03-2.198h-.008Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M49.17 28.03H14.83v-2.5h34.34v2.5ZM47.17.4H16.84C8.28.4 1.32 7.36 1.32 15.92v46.43c0 .51.3.96.77 1.16.16.06.32.09.48.09.33 0 .64-.13.88-.37l10.07-10.07h18.92c-.18-.82-.3-1.65-.36-2.5h-19.2c-.51 0-.95.31-1.15.75l-7.92 7.92V15.92C3.81 8.74 9.65 2.9 16.83 2.9h30.33c7.18 0 13.02 5.84 13.02 13.02v21.75c.05.05.1.08.14.13.8.8 1.5 1.66 2.1 2.57.16-.89.26-1.8.26-2.73V15.92C62.68 7.36 55.72.4 47.16.4h.01ZM14.83 40.26H32v-2.5H14.83v2.5ZM49.17 13.3H14.83v2.5h34.34v-2.5Zm9.39 26.26c5.5 5.5 5.5 14.41 0 19.91s-14.41 5.5-19.91 0-5.5-14.41 0-19.91 14.41-5.5 19.91 0Zm-.95 8.6-7.54-.09v-7.54h-2.93v7.51l-7.5-.09-.03 2.93 7.54.09v7.54h2.93V51l7.5.09.04-2.93h-.01Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCommentsAdd = function IconCommentsAdd(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Comments Add' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CommentsAdd"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCommentsAdd.sizes = [16, 24, 32, 48, 64];
IconCommentsAdd.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCommentsAdd;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/CommentsAdd.js
// module id = 1693
// module chunks = 0